export const parseEmailDomains = (value: string | undefined): string[] => {
	if (!value) {
		return [];
	}

	return value
		.split(',')
		.map((domain) => domain.trim())
		.filter((domain) => domain.length > 0);
};
